import { Component } from '@angular/core';

@Component({
    selector: 'app-capture-history-item-title',
    template: '<strong><ng-content /></strong>'
})
export class CaptureHistoryItemTitleComponent {}
